import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../services/authService';

/**
 * Custom hook for managing admin revenue data
 * Handles fetching revenue data with period filtering
 */
export const useAdminRevenue = (initialPeriod = 'month') => {
  const [period, setPeriod] = useState(initialPeriod);

  const periodOptions = [
    { value: 'week', label: 'Last Week' },
    { value: 'month', label: 'Last Month' },
    { value: 'quarter', label: 'Last Quarter' },
    { value: 'year', label: 'Last Year' },
    { value: 'all', label: 'All Time' }
  ];

  const { data: revenueResponse, isLoading, error, refetch } = useQuery({
    queryKey: ['adminRevenue', period],
    queryFn: async () => {
      const response = await api.get(`/admin/revenue?period=${period}`);
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // Data considered fresh for 5 minutes
  });

  const revenue = revenueResponse?.data || {};

  return {
    // Data
    revenue,
    isLoading,
    error,
    
    // Period management
    period,
    setPeriod,
    periodOptions,
    
    // Actions
    refetch
  };
};

